import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';

const ConditionalTooltip = ({ title, placement, enterDelay, open, children }) => {
  if (!title || !open) {
    return children;
  }
  return (
    <Tooltip
      title={title}
      placement={placement}
      enterDelay={enterDelay}
    >
      <div>
        {children}
      </div>
    </Tooltip>
  );
};

ConditionalTooltip.propTypes = {
  title: PropTypes.string,
  placement: PropTypes.string,
  enterDelay: PropTypes.number,
  open: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

ConditionalTooltip.defaultProps = {
  title: undefined,
  placement: 'top-start',
  enterDelay: undefined,
  open: true,
};

export default ConditionalTooltip;
